var sprintf = require('./sprintf');

module.exports = function vsprintf(fmt, argv) {
  argv.unshift(fmt);
  return sprintf.apply(null, argv);
};



//////////////////
// WEBPACK FOOTER
// ../~/underscore.string/vsprintf.js
// module id = 448
// module chunks = 0